export const environment = {
  name: 'development',
  production: false,
  baseUrlMuvStok: 'https://dev.api.muvstok.com.br',
  urlMovidesk: 'https://muvstok.movidesk.com/',
  identityURL: 'https://dev.serviceshub.com.br',
  realm: 'muvstok-dev',
  clientId: 'muvstok',
};
